var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1334a3",
    d: "M0 15h30v3H0zm0 9v-3h30v3zM14 9h16v3H14zm16-6H14v3h16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6d44a",
    d: "M11.07 8.51c-.3-.08-.65-.17-1.07-.55l2.5-.46-2.63-.48c1.25-.48.94-1.37 2.21-1.3-1.13-.69-1.32.33-2.5.33l1.46-2.08-2.19 1.5c.57-1.24-.32-1.61.63-2.46-1.29.31-.7 1.16-1.53 2L7.5 2.5l-.48 2.61c-.48-1.19-1.38-.95-1.3-2.2-.69 1.14.33 1.32.33 2.5L3.96 3.96l1.51 2.18c-1.24-.57-1.61.33-2.46-.63.31 1.3 1.16.7 1.99 1.53l-2.5.45 2.61.48c-1.27.48-.91 1.37-2.19 1.3 1.01.68 1.37-.31 2.5-.33l-1.45 2.09 2.18-1.51c-.58 1.25.33 1.61-.63 2.47 1.29-.32.7-1.17 1.53-2l.45 2.5.48-2.62c.48 1.27 1.37.93 1.3 2.2.69-1.13-.33-1.32-.33-2.49l2.09 1.45-1.52-2.18c1.24.56 1.62-.33 2.47.63-.13-.62-.5-.92-.92-.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.7f6c91dc6583f6bc47ae8fd640dbdbd1.svg";
export { ForwardRef as ReactComponent };